import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_CMS_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { CMS_SIGNUP_BUSINESS_INTENT } from '../constants/surveyConstants';
import { isUngatedFor } from '../utils/authUtils';
import { getAiOnboardingFlowUrl, HubletUrl } from '../utils/urls';
import { BLOG_NEW_ONBOARDING_FLOW, CONTENT_HUB_ONBOARDING } from '../constants/gateConstants';
import { CMS_FREE_SIGNUP } from '../constants/signupConstants';

const maybeGetOverrideCmsGroupKey = (baseGroupKey, auth) => {
  if (auth) {
    if (isUngatedFor(auth, CONTENT_HUB_ONBOARDING)) {
      // this group contains create-a-blog-task (from -v2 groups)
      return FREE_GROUP_KEYS.freeContentView;
    } else if (isUngatedFor(auth, BLOG_NEW_ONBOARDING_FLOW)) {
      return `${baseGroupKey}-v2`;
    }
  }

  return baseGroupKey;
};

const cmsExperiencesChecks = [{
  redirectPath: (portalId, auth) => {
    return {
      url: getAiOnboardingFlowUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignup, auth)
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP,
    survey: {
      cmsSignupIntent: CMS_SIGNUP_BUSINESS_INTENT
    }
  }]
}, {
  redirectPath: (portalId, auth) => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: maybeGetOverrideCmsGroupKey(FREE_GROUP_KEYS.freeCmsViewCmsSignup, auth)
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP
  }]
}];
export default cmsExperiencesChecks;